define('modules/lp_info/views/variant_line',['require','exports','module','base/itemview','./confirm_delete_popup','./copy_to_popup','lib/util','env','common/views/alert_view','ldsh!../templates/variant_line'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview"),
      ConfirmDeletePopup = require("./confirm_delete_popup"),
      CopyToPopup = require("./copy_to_popup"),
      util = require("lib/util"),
      config = require("env"),
      AlertView = require("common/views/alert_view");

  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  var Controller = {
    makeMainVariant: function(e) {
      e.preventDefault();
      this.model.setAsMain();
    },

    deleteVariant: function(e) {
      e.preventDefault();
      e.stopPropagation();
      var currentModel = this.model;

      if (config.avoidConfirmMessages) {
        currentModel.destroy(undefined, undefined);
        return util.hotPageReload();
      }

      ConfirmDeletePopup.show(currentModel)
        .then(
          function () {
            currentModel.destroy(undefined, undefined);
            return util.hotPageReload();
          }
        );
    },

    setWeight: function(e) {
      e.preventDefault();
      e.stopPropagation();
      var input = this.$(".js-vweight-input");

      function isValid(amount){
        return !isNaN(amount) && amount >= 0 && amount <= 100;
      }

      var weight = +input.val();
      if (isValid(weight)) {
        input.removeClass("is-invalid");
        this.trigger("weight:set", this.model, Math.floor(weight));
        this.toggleWeightForm(false);
      } else {
        input.addClass("is-invalid");
      }
    },

    editName: function(e) {
      e.preventDefault();
      this.toggleNameForm(true);
    },

    editWeight: function(e) {
      e.preventDefault();
      this.toggleWeightForm(true);
    },

    regenerateThumbnail: function(e) {
      e.preventDefault();
      this.model.save({  }, {
          patch: true,
          success: function() {
            AlertView.showAlert({
              message: $.i18n.t("pageListing.thumbnailRegenerated"),
              alertType: "success"
            });
          }
        });
    },

    saveName: function(e) {
      var self = this,
          newName = this.$(".js-vname-input").val(),
          saveButton = this.$(".js-vname-save");

      e.preventDefault();
      if(newName !== this.model.get("name")){
        //prevent doubleclick
        saveButton.attr("disabled", "disabled")
          .addClass("is-disabled")
          .text($.i18n.t("common.savingText"));
        this.model.save({ name : newName}, {
          patch: true,
          success: function(){
            //restore button
            saveButton.attr("disabled", "")
              .removeClass("is-disabled")
              .text($.i18n.t("common.saveButton"));
            self.toggleNameForm(false);
          }
        });
      }
      else {
        this.toggleNameForm(false);
      }
    },

    copyTo: function(e) {
      e.preventDefault();
      e.stopPropagation();
      CopyToPopup.show(this.model);
    },

    toggleNameForm: function(display) {
      this.$(".js-vname").toggle(!display);
      if(display){
        this.$(".js-vname-edit").fadeIn();
        this.$(".js-vname-input").focus();
      }
      else {
        this.$(".js-vname-edit").hide();
      }
    },

    toggleWeightForm: function(display) {
      this.$(".js-vweight").toggle(!display);
      if(display){
        this.$(".js-vweight-edit").fadeIn();
        this.$(".js-vweight-input").focus();
      }
      else {
        this.$(".js-vweight-edit").hide();
      }
    },

    showEditButton: function() {
      this.$(".js-edit-vname").show();
    },

    hideEditButton: function() {
      this.$(".js-edit-vname").hide();
    },

    hideNameForm: function(e) {
      e.preventDefault();
      this.toggleNameForm(false);
    },

    hideWeightForm: function(e) {
      e.preventDefault();
      var oldWeight = this.model.get("weight"),
          input = this.$(".js-vweight-input");
      input.val(oldWeight);
      input.removeClass("is-invalid");
      this.toggleWeightForm(false);
    }
  };

  module.exports = ItemView.extend({
    tagName: "tr",
    template: require("ldsh!../templates/variant_line"),

    events: {
      "click .js-make-main": "makeMainVariant",
      "click .js-delete": "deleteVariant",
      "click .js-edit-vname": "editName",
      "click .js-edit-vweight": "editWeight",
      "click .js-vname-cancel": "hideNameForm",
      "click .js-vname-save": "saveName",
      "click .js-copy-to-variant": "copyTo",
      "submit .js-vweight-form": "setWeight",
      "focusout .js-vweight-input": "hideWeightForm",
      "mouseover .js-vname": "showEditButton",
      "mouseout .js-vname": "hideEditButton",
      "click .js-regenerate-thumbnail": "regenerateThumbnail"
    },

    triggers: {
      "click .js-duplicate-variant": "duplicate",
      "click .js-discard": "discard",
      "click .js-reactivate": "reactivate"
    },

    helpers: function() {
      var safeName = escapeHtml(this.model.get("name"));

      if(safeName.length > 100){
        safeName = safeName.substr(0, 99) + "...";
      }

      return {
        escapedName: safeName,
        platformIcon: util.getVariantIcon(this.model.get('platform'))
      };
    }
  });

  util.mixin(module.exports, Controller);
});

